import { useEffect, useState } from 'react';

export const useMessageCycle = (
  isActive: boolean,
  messages: string[],
  intervalMs: number = 3000
): string => {
  const [currentMessage, setCurrentMessage] = useState(messages[0]);

  useEffect(() => {
    if (!isActive) {
      setCurrentMessage(messages[0]);
      return;
    }

    let index = 0;
    const interval = setInterval(() => {
      index = (index + 1) % messages.length;
      setCurrentMessage(messages[index]);
    }, intervalMs);

    return () => clearInterval(interval);
  }, [isActive, messages, intervalMs]);

  return currentMessage;
};
